var _dec, _class, _class2;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/** @jsx jsx */
import { Component } from 'react';
import { IconCheckSolid, IconXSolid } from '@instructure/ui-icons';
import { withStyle, jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { propTypes, allowedProps } from './props';
/**
---
parent: Checkbox
---
@tsProps
**/
let ToggleFacade = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = class ToggleFacade extends Component {
  constructor() {
    super(...arguments);
    this.ref = null;
    this.handleRef = el => {
      this.ref = el;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  renderIcon() {
    const _this$props3 = this.props,
      styles = _this$props3.styles,
      checked = _this$props3.checked;
    if (checked) {
      return jsx(IconCheckSolid, {
        css: styles === null || styles === void 0 ? void 0 : styles.iconSVG
      });
    } else {
      return jsx(IconXSolid, {
        css: styles === null || styles === void 0 ? void 0 : styles.iconSVG
      });
    }
  }
  renderLabel() {
    const _this$props4 = this.props,
      children = _this$props4.children,
      styles = _this$props4.styles;
    return jsx("span", {
      css: styles === null || styles === void 0 ? void 0 : styles.label
    }, children);
  }
  render() {
    const _this$props5 = this.props,
      labelPlacement = _this$props5.labelPlacement,
      styles = _this$props5.styles;
    return jsx("span", {
      css: styles === null || styles === void 0 ? void 0 : styles.toggleFacade,
      ref: this.handleRef
    }, (labelPlacement === 'top' || labelPlacement === 'start') && this.renderLabel(), jsx("span", {
      css: styles === null || styles === void 0 ? void 0 : styles.facade,
      "aria-hidden": "true"
    }, jsx("span", {
      css: styles === null || styles === void 0 ? void 0 : styles.icon
    }, jsx("span", {
      css: styles === null || styles === void 0 ? void 0 : styles.iconToggle
    }, this.renderIcon()))), labelPlacement === 'end' && this.renderLabel());
  }
}, _class2.displayName = "ToggleFacade", _class2.componentId = 'ToggleFacade', _class2.propTypes = propTypes, _class2.allowedProps = allowedProps, _class2.defaultProps = {
  checked: false,
  focused: false,
  size: 'medium',
  disabled: false,
  readOnly: false,
  labelPlacement: 'end'
}, _class2)) || _class);
export default ToggleFacade;
export { ToggleFacade };